import React from "react";

import copyToClipboard from "copy-to-clipboard";

import { NOTIFICATIONS } from "shared/config/constants";
import { openNotification } from "shared/utils/ui";

import { CopyUuidButton, UuidCell } from "./styled";

interface CosignCopyUuidProps {
  uuid: string | null | undefined;
  label?: string;
  testId?: string;
}

/**
 * Displays a UUID with a one-click copy action for support handoffs.
 *
 * @param uuid - Full UUID string to display and copy.
 * @param label - Accessible label prefix for the copy button.
 * @param testId - Optional test id for the value element.
 */
const CosignCopyUuid: React.FC<CosignCopyUuidProps> = ({
  uuid,
  label = "UUID",
  testId,
}) => {
  if (!uuid) {
    return <span data-testid={testId}>—</span>;
  }

  const onCopy = () => {
    copyToClipboard(uuid);
    openNotification(`${label} copied to clipboard.`, NOTIFICATIONS.info);
  };

  return (
    <UuidCell>
      <span data-testid={testId}>{uuid}</span>
      <CopyUuidButton
        type="button"
        onClick={onCopy}
        data-testid={testId ? `${testId}-copy` : "cosign-uuid-copy"}
        aria-label={`Copy ${label}`}
      >
        Copy
      </CopyUuidButton>
    </UuidCell>
  );
};

export default CosignCopyUuid;
